
export const PAN_REGEX = /^[A-Z]{5}[0-9]{4}[A-Z]$/;

export const MOBILE_REGEX = /^[6-9]\d{9}$/;

export const OTP_RESEND_SECONDS = 30;

export const LOAN_PURPOSES = [
  "Personal Use",
  "Medical Emergency",
  "Education",
  "Wedding",
  "Travel",
  "Home Renovation",
  "Other",
];

export const EMPLOYMENT_TYPES = [
  "Salaried",
  "Self Employed",
];

export const SALARY_MODES = [
  "Bank Transfer",
  "Cheque",
  "Cash",
];

export const REFERENCE_RELATIONS = [
  "Mother",
  "Father",
  "Brother",
  "Sister",
  "Spouse",
  "Friend",
  "Colleague",
  "Other",
];

export const VERIFY_STEPS = [
  "Checking your details...",
  "Verifying employment...",
  "Reviewing loan eligibility...",
];

export const NAME_MATCH_THRESHOLD = 70;